// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "loyalty-ZsSJ9";
var _4 = "loyalty__awardedInfo-2fDHH";
var _5 = "loyalty__paper-Duwp5";
export { _1 as "__esModule", _2 as "mobile", _3 as "loyalty", _4 as "loyalty__awardedInfo", _5 as "loyalty__paper" }
export default { "__esModule": _1, "mobile": _2, "loyalty": _3, "loyalty__awardedInfo": _4, "loyalty__paper": _5 }
